import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=da2f143a&scoped=true&"
import script from "./pc.vue?vue&type=script&lang=js&"
export * from "./pc.vue?vue&type=script&lang=js&"
import style0 from "./pc.vue?vue&type=style&index=0&id=da2f143a&prod&scoped=true&lang=scss&"
import style1 from "./pc.vue?vue&type=style&index=1&id=da2f143a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2f143a",
  null
  
)

export default component.exports